import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { ServerCommunicatorService } from "./server-communicator.service";
import { UserLoginResponse } from "../classes/infrastructure/request_response/userloginresponse";
import { ServiceInjector } from "../classes/infrastructure/injector";
import { NavItem_Entity_Authority } from "../shared/components/side-navigation-menu/side-navigation-menu.component";

@Injectable({
  providedIn: "root",
})
export class SidebarMenuStateService {
  public static GetInstance(): SidebarMenuStateService {
    return ServiceInjector.AppInjector.get(SidebarMenuStateService);
  }
  // private menuSubject = new BehaviorSubject<any[]>([]);
  // menu$ = this.menuSubject.asObservable();

  // constructor(private serverService: ServerCommunicatorService) { }

  // async loadMenu() {
  //     // clear previous data first
  //     this.menuSubject.next([]);

  //     const res = await this.serverService.GetValidMenuItemList();
  //     console.log('res :', res);

  //     this.menuSubject.next(res?.ValidMenuItemIds2 || []);
  // }

  // clearMenu() {
  //     this.menuSubject.next([]);
  // }

  // 🔹 Auth & user info
  private tokenSubject = new BehaviorSubject<string | null>(null);
  token$ = this.tokenSubject.asObservable();

  private userRefSubject = new BehaviorSubject<number | null>(null);
  userRef$ = this.userRefSubject.asObservable();

  private postRefSubject = new BehaviorSubject<number | null>(null);
  postRef$ = this.postRefSubject.asObservable();

  private undersupervisionpostRefSubject = new BehaviorSubject<number | null>(
    null,
  );
  undersupervisionpostRef$ = this.undersupervisionpostRefSubject.asObservable();

  private roleSubject = new BehaviorSubject<number | null>(null);
  role$ = this.roleSubject.asObservable();

  private roleNameSubject = new BehaviorSubject<string | null>(null);
  roleName$ = this.roleNameSubject.asObservable();

  private userNameSubject = new BehaviorSubject<string | null>(null);
  userName$ = this.userNameSubject.asObservable();

    private profilePicPathSubject = new BehaviorSubject<string | null>(null);
  profilePicPath$ = this.profilePicPathSubject.asObservable();

  // 🔹 Financial / config
  private financialYearsSubject = new BehaviorSubject<any[]>([]);
  financialYears$ = this.financialYearsSubject.asObservable();

  private monthsSubject = new BehaviorSubject<number[]>([]);
  months$ = this.monthsSubject.asObservable();

  // 🔹 Permissions / menu
  private menuSubject = new BehaviorSubject<NavItem_Entity_Authority[]>([]);
  menu$ = this.menuSubject.asObservable();

  private districtrefSubject = new BehaviorSubject<number | null>(null);
  districtref$ = this.districtrefSubject.asObservable();

  private blockrefSubject = new BehaviorSubject<number | null>(null);
  blockref$ = this.blockrefSubject.asObservable();

  private phcrefSubject = new BehaviorSubject<number | null>(null);
  phcref$ = this.phcrefSubject.asObservable();

  // Add this with the other subjects
  private isReadySubject = new BehaviorSubject<boolean>(false);
  isReady$ = this.isReadySubject.asObservable();

  // PHC EN 
  private phcSubjectEn = new BehaviorSubject<string | null>(null);
  phcEn$ = this.phcSubjectEn.asObservable();

  // SC EN
  private scSubjectEn = new BehaviorSubject<string | null>(null);
  scEn$ = this.scSubjectEn.asObservable();

  // Village EN
  private villageSubjectEn = new BehaviorSubject<string | null>(null);
  villageEn$ = this.villageSubjectEn.asObservable();

  // PHC MR 
  private phcSubjectMr = new BehaviorSubject<string | null>(null);
  phcMr$ = this.phcSubjectMr.asObservable();

  // SC MR
  private scSubjectMr = new BehaviorSubject<string | null>(null);
  scMr$ = this.scSubjectMr.asObservable();

  // Village MR
  private villageSubjectMr = new BehaviorSubject<string | null>(null);
  villageMr$ = this.villageSubjectMr.asObservable();

  private userDisplayNameEnSubject = new BehaviorSubject<string | null>(null);
  userDisplayNameEn$ = this.userDisplayNameEnSubject.asObservable();

  private userDisplayNameMrSubject = new BehaviorSubject<string | null>(null);
  userDisplayNameMr$ = this.userDisplayNameMrSubject.asObservable();

  private roleNameEnSubject = new BehaviorSubject<string | null>(null);
  roleNameEn$ = this.roleNameEnSubject.asObservable();

  private roleNameMrSubject = new BehaviorSubject<string | null>(null);
  roleNameMr$ = this.roleNameMrSubject.asObservable();

  private storage = sessionStorage;

  constructor() {
    this.rehydrateFromStorage();
  }

  // 🔥 SINGLE METHOD TO SET EVERYTHING
  // async loadLoginUserWiseResponse() {
  //     this.clearState();
  //     // debugger
  //     const res = await this.server.GetValidMenuItemList();
  //     console.log(res, 'res 1');
  //     let Data = res.ObjectTag
  //     // if (!res?.Successful) return;

  //     this.tokenSubject.next(Data.LoginToken);
  //     this.userRefSubject.next(Data.LoginUserRef);
  //     this.roleSubject.next(Data.Role);
  //     this.roleNameSubject.next(Data.RoleName);
  //     this.userNameSubject.next(Data.UserDisplayName);

  //     this.financialYearsSubject.next(Data.FinancialYearResponses || []);
  //     this.monthsSubject.next(Data.Months || []);
  //     this.menuSubject.next(Data.ValidMenuItemIds2 || []);
  //     // console.log(res, 'res 2');

  // }
  setLoginUserData(data: any) {
    console.log("data :", data);
    // debugger
    this.tokenSubject.next(data.LoginUserToken);
    this.userRefSubject.next(data.LoginUserRef);
    this.postRefSubject.next(data.PostRef);
    this.undersupervisionpostRefSubject.next(data.UnderSupervisionPostRef);
    this.roleSubject.next(data.Role);
    this.roleNameSubject.next(data.RoleName);
    this.userNameSubject.next(data.UserDisplayName);
    this.profilePicPathSubject.next(data.ProfilePicPath);
    this.monthsSubject.next(data.Months || []);
    this.financialYearsSubject.next(data.FinancialYearResponses || []);
    // this.menuSubject.next(data.ValidMenuItemIds2 || []);


    // ✅ Fixed — map to NavItem_Entity_Authority shape
    const rawItems: any[] = data.ValidMenuItemIds2 ?? [];
    const navItems: NavItem_Entity_Authority[] = rawItems.map(item => ({
      Feature: item.feature,
      FeatureGroup: item.feature_group,
      MenuId: item.menu_id,
      CanAdd: item.can_add,
      CanView: item.can_view,
      CanEdit: item.can_edit,
      CanDelete: item.can_delete,
      CanExport: item.can_export,
    }));
    this.menuSubject.next(navItems);

    this.districtrefSubject.next(data.DisrictRef);
    this.blockrefSubject.next(data.BlockRef);
    this.phcrefSubject.next(data.PHCRef);

    this.phcSubjectEn.next(data.PHCNameEn);
    this.scSubjectEn.next(data.SCNameEn);
    this.villageSubjectEn.next(data.VillageNameEn);
    this.phcSubjectMr.next(data.PHCNameMr);
    this.scSubjectMr.next(data.SCNameMr);
    this.villageSubjectMr.next(data.VillageNameMr);

    this.userDisplayNameEnSubject.next(data.UserDisplayNameEn);
    this.userDisplayNameMrSubject.next(data.UserDisplayNameMr);
    this.roleNameEnSubject.next(data.RoleNameEn);
    this.roleNameMrSubject.next(data.RoleNameMr);

    this.storage.setItem('PHCNameEn', data.PHCNameEn ?? '');
    this.storage.setItem('PHCNameMr', data.PHCNameMr ?? '');
    this.storage.setItem('SCNameEn', data.SCNameEn ?? '');
    this.storage.setItem('SCNameMr', data.SCNameMr ?? '');
    this.storage.setItem('VillageNameEn', data.VillageNameEn ?? '');
    this.storage.setItem('VillageNameMr', data.VillageNameMr ?? '');
    this.storage.setItem('UserDisplayNameEn', data.UserDisplayNameEn ?? '');
    this.storage.setItem('UserDisplayNameMr', data.UserDisplayNameMr ?? '');
    this.storage.setItem('RoleNameEn', data.RoleNameEn ?? '');
    this.storage.setItem('RoleNameMr', data.RoleNameMr ?? '');

    this.storage.setItem('LoginToken', data.LoginUserToken ?? '');
    this.storage.setItem('LoginUserRef', data.LoginUserRef?.toString() ?? '');
    this.storage.setItem('Role', data.Role?.toString() ?? '');
    this.storage.setItem('RoleName', data.RoleName ?? '');
    this.storage.setItem('UserDisplayName', data.UserDisplayName ?? '');
    this.storage.setItem('ProfilePicPath', data.ProfilePicPath ?? '');
    this.storage.setItem('PostRef', data.PostRef?.toString() ?? '');
    this.storage.setItem('UnderSupervisionPostRef', data.UnderSupervisionPostRef?.toString() ?? '');
    this.storage.setItem('Months', JSON.stringify(data.Months || []));

    // this.storage.setItem('ValidMenuItemIds2', JSON.stringify(data.ValidMenuItemIds2 || []));

    this.storage.setItem('ValidMenuItemIds2', JSON.stringify(navItems));

    this.isReadySubject.next(true);
  }

  clearState() {
    this.tokenSubject.next(null);
    this.userRefSubject.next(null);
    this.roleSubject.next(null);
    this.roleNameSubject.next(null);
    this.userNameSubject.next(null);
    this.profilePicPathSubject.next(null);

    this.financialYearsSubject.next([]);
    this.monthsSubject.next([]);
    this.menuSubject.next([]);
    this.isReadySubject.next(false);

    this.phcSubjectEn.next(null);
    this.phcSubjectMr.next(null);
    this.scSubjectEn.next(null);
    this.scSubjectMr.next(null);
    this.villageSubjectEn.next(null);
    this.villageSubjectMr.next(null);
    this.userDisplayNameEnSubject.next(null);
    this.userDisplayNameMrSubject.next(null);
    this.roleNameEnSubject.next(null);
    this.roleNameMrSubject.next(null);

    // ✅ Clear localStorage too
    // localStorage.removeItem('PHCNameEn');
    // localStorage.removeItem('PHCNameMr');
    // localStorage.removeItem('SCNameEn');
    // localStorage.removeItem('SCNameMr');
    // localStorage.removeItem('VillageNameEn');
    // localStorage.removeItem('VillageNameMr');
    // localStorage.removeItem('UserDisplayNameEn');
    // localStorage.removeItem('UserDisplayNameMr');
    // localStorage.removeItem('RoleNameEn');
    // localStorage.removeItem('RoleNameMr');
    // localStorage.removeItem('ValidMenuItemIds2');

    // localStorage.removeItem('LoginToken');
    // localStorage.removeItem('LoginUserRef');
    // localStorage.removeItem('Role');
    // localStorage.removeItem('RoleName');
    // localStorage.removeItem('UserDisplayName');
    // localStorage.removeItem('PostRef');
    // localStorage.removeItem('UnderSupervisionPostRef');
    // localStorage.removeItem('Months');
    // localStorage.removeItem('ValidMenuItemIds2');

    this.storage.clear();
  }

  getUserRef(): number {
    return this.userRefSubject.value ?? 0;
  }
  getUnderSupervisionPostRef(): number {
    return this.undersupervisionpostRefSubject.value ?? 0;
  }
  getPostRef(): number {
    return this.postRefSubject.value ?? 0;
  }
  getToken(): string {
    return this.tokenSubject.value ?? "";
  }
  getRole(): number {
    return this.roleSubject.value ?? 0;
  }
  getRolename(): string {
    return this.roleNameSubject.value ?? "";
  }
  getUserName(): string {
    return this.userNameSubject.value ?? "";
  }
  getProfilePicPath(): string {
    return this.profilePicPathSubject.value ?? "";
  }
  getDistrictRef(): number {
    return this.districtrefSubject.value ?? 0;
  }
  getBlockRef(): number {
    return this.blockrefSubject.value ?? 0;
  }
  getPHCRef(): number {
    return this.phcrefSubject.value ?? 0;
  }
  getMenu(): NavItem_Entity_Authority[] {
    // console.log("this.menuSubject.value :", this.menuSubject.value);
    return this.menuSubject.value ?? [];
  }

  // getPHCNameEn(): string {
  //   return this.phcSubjectEn.value ?? "";
  // }
  // getSCNameEn(): string {
  //   return this.scSubjectEn.value ?? "";
  // }
  // getVillageNameEn(): string {
  //   return this.villageSubjectEn.value ?? "";
  // }

  // getPHCNameMr(): string {
  //   return this.phcSubjectMr.value ?? "";
  // }
  // getSCNameMr(): string {
  //   return this.scSubjectMr.value ?? "";
  // }
  // getVillageNameMr(): string {
  //   return this.villageSubjectMr.value ?? "";
  // }

  // getUserDisplayNameEn(): string {
  //   return this.userDisplayNameEnSubject.value ?? "";
  // }
  // getUserDisplayNameMr(): string {
  //   return this.userDisplayNameMrSubject.value ?? "";
  // }
  // getRoleNameEn(): string {
  //   return this.roleNameEnSubject.value ?? "";
  // }
  // getRoleNameMr(): string {
  //   return this.roleNameMrSubject.value ?? "";
  // }

  getPHCNameEN(): string {
    return this.storage.getItem("PHCNameEn") ?? "";
  }
  getPHCNameMR(): string {
    return this.storage.getItem("PHCNameMr") ?? "";
  }
  getSCNameEN(): string {
    return this.storage.getItem("SCNameEn") ?? "";
  }
  getSCNameMR(): string {
    return this.storage.getItem("SCNameMr") ?? "";
  }
  getVillageNameEn(): string {
    return this.storage.getItem("VillageNameEn") ?? "";
  }
  getVillageNameMr(): string {
    return this.storage.getItem("VillageNameMr") ?? "";
  }
  getUserDisplayNameEN(): string {
    return this.storage.getItem("UserDisplayNameEn") ?? "";
  }
  getUserDisplayNameMR(): string {
    return this.storage.getItem("UserDisplayNameMr") ?? "";
  }
  getRoleNameEN(): string {
    return this.storage.getItem("RoleNameEn") ?? "";
  }
  getRoleNameMR(): string {
    return this.storage.getItem("RoleNameMr") ?? "";
  }

  setMenuOnly(objectTag: any) {
    const rawItems: any[] = objectTag?.valid_web_menu_item_ids  ?? [];

    const navItems: NavItem_Entity_Authority[] = rawItems.map(item => ({
      Feature: item.feature,
      FeatureGroup: item.feature_group,
      MenuId: item.menu_id,
      CanAdd: item.can_add,
      CanView: item.can_view,
      CanEdit: item.can_edit,
      CanDelete: item.can_delete,
      CanExport: item.can_export,
    }));

    this.menuSubject.next(navItems);
    this.isReadySubject.next(true);
    this.profilePicPathSubject.next(objectTag?.profile_pic_path ?? '');
  
    // ✅ Keep sessionStorage in sync
  this.storage.setItem('ValidMenuItemIds2', JSON.stringify(navItems));
  }

  // Single method all components should use — no raw sessionStorage reads
getEntityAuthority(menuId: string): NavItem_Entity_Authority | undefined {
  return this.menuSubject.value.find(e => e.MenuId === menuId);
}
  
  rehydrateFromStorage() {
    const token = this.storage.getItem('LoginToken');
    if (!token) return; // not logged in yet

    this.tokenSubject.next(token);
    this.userRefSubject.next(Number(this.storage.getItem('LoginUserRef')) || null);
    this.roleSubject.next(Number(this.storage.getItem('Role')) || null);
    this.roleNameSubject.next(this.storage.getItem('RoleName') ?? '');
    this.userNameSubject.next(this.storage.getItem('UserDisplayName') ?? '');
    this.profilePicPathSubject.next(this.storage.getItem('ProfilePicPath') ?? '');
    this.postRefSubject.next(Number(this.storage.getItem('PostRef')) || null);
    this.undersupervisionpostRefSubject.next(Number(this.storage.getItem('UnderSupervisionPostRef')) || null);

    const months = this.storage.getItem('Months');
    this.monthsSubject.next(months ? JSON.parse(months) : []);

    const menu = this.storage.getItem('ValidMenuItemIds2');
    
    this.menuSubject.next(menu ? JSON.parse(menu) : []);

    this.phcSubjectEn.next(this.storage.getItem('PHCNameEn') ?? '');
    this.phcSubjectMr.next(this.storage.getItem('PHCNameMr') ?? '');
    this.scSubjectEn.next(this.storage.getItem('SCNameEn') ?? '');
    this.scSubjectMr.next(this.storage.getItem('SCNameMr') ?? '');
    this.villageSubjectEn.next(this.storage.getItem('VillageNameEn') ?? '');
    this.villageSubjectMr.next(this.storage.getItem('VillageNameMr') ?? '');
    this.userDisplayNameEnSubject.next(this.storage.getItem('UserDisplayNameEn') ?? '');
    this.userDisplayNameMrSubject.next(this.storage.getItem('UserDisplayNameMr') ?? '');
    this.roleNameEnSubject.next(this.storage.getItem('RoleNameEn') ?? '');
    this.roleNameMrSubject.next(this.storage.getItem('RoleNameMr') ?? '');

    this.isReadySubject.next(true);
  }
}
